import { getFirestore } from "firebase/firestore";
import {initializeApp} from "@firebase/app";
import {authDomain} from "./config";
import {getAuth} from "firebase/auth";


export const firebaseApp = initializeApp({
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: authDomain,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_SENDER_ID,
});
export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);

